import React, { useContext, useEffect, useRef, useState } from 'react'
import './Newkendra.css'
import { useLocation, useNavigate } from 'react-router-dom';
import back from "../../imgs/backexam.png";
import user from "../../imgs/userlogo.png";
import location from "../../imgs/location.png";
import mobile from "../../imgs/mobile.png";
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UilEditAlt } from '@iconscout/react-unicons'
import { Modal } from "bootstrap";
import Globalcontext from '../../Context/Globalcontext';
import { useTranslation } from "react-i18next";

const Newkendra = (props) => {
    const { t } = useTranslation();

    const refdelete = useRef(null);
    const refdeleteclose = useRef(null);

    const refnewkendra = useRef(null);
    const refnewkedraclose = useRef(null);
    const [showreport, setShowreport] = useState(true);
    const [firstornot, setfirstornot] = useState("Yes");
    const [showModal, setShowModal] = useState(false);
    const { submenu, setsubmenu, newcustsource, setNewcustsource, kendrasource, setKendrasource } = useContext(Globalcontext);
    const navigate = useNavigate();
    const inputRefs = useRef([]);

    const closeModal = () => {
        setShowModal(false);
    };

    const [imageurl, setImageUrl] = useState();
    const [input, setInput] = useState({ sr: "", cname: "", city: "", mobno: localStorage.getItem("contact"), type: "", status: "On", kendracount: "", citynew: "", parent: "" });
    const [mastermenu, setMastermenu] = useState(true);
    const [newedit, setNewedit] = useState("new");
    const [value, setValue] = useState('');
    const [DataSource, setDataSource] = useState([]);
    const [DataSource2, setDataSource2] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [type, setType] = useState({});
    const [contactdelete, setContactdelete] = useState({});

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);

    const clearAll = () => {
        setInput({ sr: "", cname: "", mobno: "", city: "" });
    }

    const handleReport = () => {
        setShowreport(true);
        getkendralist();
    }

    const closereport = () => {
        setShowreport(false);
    }

    useEffect(() => {
        if (showreport) {
            getkendralist();
        }
    }, [showreport])

    async function getkendralist() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getkendra2.php', { mainuser: localStorage.getItem("contactplant"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data) {
                    setDataSource(response.data);

                    response.data.map((user, index) => {
                        if (user.status === "On") {
                            localStorage.setItem("contact", user.mobno);
                        }
                    });

                    setTimeout(() => { props.setProgress(100); }, 200);
                }
            }).catch(err => {
                console.log(err);
            });
    }

    async function getkendracount() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getkendracount.php', { mainuser: localStorage.getItem("contactplant"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data) {
                    response.data.map((user, index) => {

                        setInput(prevInput => ({
                            ...prevInput,
                            kendracount: user.count,
                        }));

                        if (localStorage.getItem("plant") === "No") {
                            if (user.count === "1") {
                                setShowreport(false);
                            }
                        }
                        else if (localStorage.getItem("plant") === "Yes") {
                            if (user.count === "1") {
                                if (user.kendracount === "0") {
                                    setShowreport(false);
                                }
                                else {
                                    refnewkendra.current.click();
                                }
                                return;
                            }
                            else {
                                refnewkendra.current.click();
                            }
                        }
                    });
                }
            }).catch(err => {
                console.log(err);
            });
    }

    async function getfirstkendra() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getfirstkendra.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data) {
                    response.data.map((user, index) => {
                        localStorage.setItem('ksr', user.sr);
                        setInput(prevInput => ({
                            ...prevInput,
                            sr: user.sr,
                            cname: user.name
                        }));
                    });
                    setfirstornot("No");
                }
            }).catch(err => {
                console.log(err);
            });
    }

    async function getfirstkendrasingle() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getfirstkendra.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data) {
                    response.data.map((user, index) => {
                        setInput(prevInput => ({
                            ...prevInput,
                            sr: user.sr,
                            cname: user.name,
                            city: user.city,
                            mobno: user.mobno,
                            status: user.status
                        }));
                    });
                    setNewedit("edit");
                }
            }).catch(err => {
                console.log(err);
            });
    }

    const handledeleteclose = () => {
        refdeleteclose.current.click();
    }

    const handledelete = (contact) => {
        refdelete.current.click();
        const name = "contact";
        const valuecurrent = contact;
        setContactdelete(value => ({ ...value, [name]: valuecurrent }));
    }

    const deleteAccount = () => {
        axios.post('https://excellentdairy.com/iniqtest/cust/deletlator.php', contactdelete)
            .then(function sample(response) {
                if (response.data) {
                    if (response.data === "Deleted") {
                        notify(t("Newkendra.toast.accountDeleted"));
                        refdeleteclose.current.click();
                    }
                }
            }).catch(err => {
                console.log(err);
            });
    }

    const handlenewkendraclose = () => {
        refnewkedraclose.current.click();
    }

    const handlenewkendra = (contact) => {
        if (localStorage.getItem("contact") && localStorage.getItem("contact").includes("-")) {
            notifyerror(t("Newkendra.toast.turnOnMainKendraFirst"));
            return;
        }
        getkendracount();
    }

    const handlesubmit = async (event) => {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        event.preventDefault();

        let rawData = {
            sredit: input.sr,
            name: input.cname,
            mobno: input.mobno,
            city: input.city,
            parent: input.parent,
            status: input.status,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/createkendra3.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {

            if (response.data === "Successfully saved.") {
                notify(t("Newkendra.toast.kendraCreated"));
                localStorage.setItem('kendra', input.cname);
                localStorage.setItem('city', input.city);
                localStorage.setItem("kmobno", input.mobno);
                props.setKendraValue(localStorage.getItem("kendra") + "," + localStorage.getItem("city"));
                clearAll();
                setNewedit("new");
                getfirstkendrasingle();
            }
            else if (response.data === "Mobile Number Exists") {
                notifyerror(t("Newkendra.toast.mobileExists"));
                clearAll();
                setNewedit("new");
                getfirstkendrasingle();
            }
            else if (response.data === "Successfully Updated.") {
                notify(t("Newkendra.toast.kendraUpdated"));
                if (input.status === "On") {
                    notify(t("Newkendra.toast.kendraSet", { city: input.city }));
                    localStorage.setItem("contact", input.mobno);
                    localStorage.setItem('kendra', input.cname);
                    localStorage.setItem('city', input.city);
                    localStorage.setItem("kmobno", input.mobno);
                    props.setKendraValue(localStorage.getItem("kendra") + "," + localStorage.getItem("city"));
                    clearAll();
                    setNewedit("new");
                    getmyinfo();
                }
            }
            else if (response.data === "Limit Finished!") {
                notifyerror(t("Newkendra.toast.limitFinished"));
                setInput({ cname: "", mobno: "", city: "" });
                setNewedit("new");
                clearAll();
                getfirstkendrasingle();
            }
            else if (response.data === "Incomplete information!") {
                notifyerror(t("Newkendra.toast.incompleteInfo"));
            }
        }).catch(err => {
            console.log(err);
        });
    }

    async function getmyinfo() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getmyinfo.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data) {
                    if (response.data.length > 0) {
                        response.data.map((user, index) => (
                            localStorage.setItem("name", user.dairy),
                            localStorage.setItem("tal", user.tal),
                            localStorage.setItem("dist", user.dist),
                            localStorage.setItem("username", user.username),
                            localStorage.setItem("mobile", user.mobile),
                            localStorage.setItem("status", user.status),
                            localStorage.setItem("vdate", user.vdate),
                            localStorage.setItem("bill10type", user.billtype),
                            localStorage.setItem("dur", user.dur),
                            localStorage.setItem("parent", user.parent)
                        ))
                    }
                }

                if (localStorage.getItem("status") === "Expired") {
                    notify(t("Newkendra.toast.softwareExpiredCall"));
                    localStorage.setItem("status", "");
                    localStorage.setItem("vdate", "");
                }
                else if (localStorage.getItem("status") === "Activated") {
                    getmykendra();
                }
            }).catch(err => {
                console.log(err);
            });
    }

    async function getmykendra() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getmykendra2.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data) {
                    if (response.data.length > 0) {
                        setDataSource(response.data);
                        getcustomers();
                    }
                    else {
                        localStorage.setItem("status", "true");
                        localStorage.setItem("contact", input.contact);
                        localStorage.setItem("kendra", "Not available");
                        localStorage.setItem("city", "Not available");
                        navigate("/dashboard");
                        notify(t("Newkendra.toast.welcome"));
                    }
                }
            }).catch(err => {
                console.log(err);
            });
    }

    useEffect(() => {
        if (DataSource.length > 0) {
            props.setProgress(50);
            setTimeout(() => { props.setProgress(100); }, 200);
            {
                DataSource.map((user, index) => (
                    localStorage.setItem("kendra", user.name),
                    localStorage.setItem("city", user.city),
                    localStorage.setItem("kmobno", user.mobno),
                    localStorage.setItem("ksr", user.sr)
                ))
            }
        }
    }, [DataSource2])

    async function getcustomers() {
        localStorage.setItem("custlist", JSON.stringify([]));
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getaccoounttemp.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 })
            .then(function sample(response) {
                if (response.data.length > 0) {
                    localStorage.setItem("custlist", JSON.stringify(response.data));
                    setTimeout(() => { props.setProgress(100); }, 200);
                }
                else {
                    setInput({ kno: 1 })
                }
                getratetablemh();
            }).catch(err => {
                console.log(err);
            });
    }

    async function getratetablemh() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        let typetemp = "Buffalo";
        let typeid = "1";

        try {
            const response = await axios.post('https://excellentdairy.com/dairy/php/cust/getkratevibhag.php', { vibhag: "Ratechart-1", typeid: typeid, type: typetemp, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 });
            if (response.data.length > 0) {
                localStorage.setItem("mhrates", JSON.stringify(response.data));
            }
            getratetablegay();
        } catch (error) {
            console.log(error);
        }
    }

    async function getratetablegay() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => { props.setProgress(50); }, 200);

        let typetemp = "Cow";
        let typeid = "2";

        try {
            const response = await axios.post('https://excellentdairy.com/dairy/php/cust/getkratevibhag.php', { vibhag: "Ratechart-1", typeid: typeid, type: typetemp, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 });
            if (response.data.length > 0) {
                localStorage.setItem("gayrates", JSON.stringify(response.data));
            }
            getfirstkendrasingle();
            localStorage.setItem("status", "true");
        } catch (error) {
            console.log(error);
        }
    }

    const createnewuserandkendra = async (event) => {
        if (input.citynew === undefined || input.citynew === "") {
            notifyerror(t("Newkendra.toast.fillVillageBranch"));
            return;
        }

        var mainuser2 = jsEncode.encode("mamapr", 125);
        event.preventDefault();

        let rawData = {
            newmainuser: localStorage.getItem("contact") + "-" + (parseFloat(input.kendracount) + 1),
            kendraname: localStorage.getItem("kendra"),
            kendramobno: localStorage.getItem("contact") + "-" + (parseFloat(input.kendracount) + 1),
            kendracity: input.citynew,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/createuserandkendra.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data === "Successfully saved.") {
                notify(t("Newkendra.toast.newKendraCreated"));
                setInput(prevInput => ({ ...prevInput, citynew: "" }))
                getkendralist();
                handlenewkendraclose();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleedit = (sr, name, mobno, city, status, parent) => {
        setInput({ sr: sr, cname: name, mobno: mobno, city: city, status: status, parent: parent });
        setShowreport(false);
        setNewedit("edit");
    }

    const handleChange = (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        if (name === "contact") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                valuecurrent = event.target.value;
                setInput(value => ({ ...value, [name]: valuecurrent }))
            }
        }
        else {
            if (name === "img") valuecurrent = event.target.files[0].name;
            else valuecurrent = event.target.value;
            setInput(value => ({ ...value, [name]: valuecurrent }))
        }
    }

    const filteData = (e) => {
        if (e.target.value != "") {
            setValue(e.target.value);
            const filtertable = DataSource.filter(o => Object.keys(o).some(k =>
                String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
            ));
            setTableFilter([...filtertable]);
        }
        else {
            setValue(e.target.value);
            setTableFilter([...DataSource]);
        }
    }

    const handleBack = () => {
        if (kendrasource === "Dashboard") {
            navigate("/Dashboard");
            setNewcustsource("");
            setKendrasource("");
            props.visibility();
        }
        else {
            props.visibility();
        }
    };

    const handleBacktokendra = () => {
        setShowreport(true);
    };

    useEffect(() => {
        getfirstkendrasingle();

        const modalElement = refdelete.current;
        const modal = new Modal(modalElement);

        const handleModalHide = () => {
            modal.show();
        };

        modalElement.addEventListener("hide.bs.modal", handleModalHide);

        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }

        return () => {
            modalElement.removeEventListener("hide.bs.modal", handleModalHide);
        };
    }, []);

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            handlesubmit();
            let nextIndex = null;
            if (currentIndex === 0) {
                if (input.name !== "") nextIndex = currentIndex + 1;
                else nextIndex = currentIndex;
            }
            else nextIndex = currentIndex + 1;

            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[1]) inputRefs.current[1].focus();
            }
        }
    }

    function handleEnterKey(event, currentIndex) {
        if (event.keyCode === 8) {
            if (event.target.name === "time") {
                setInput((prevInputSettings) => ({ ...prevInputSettings, time: '' }));
            }
            else if (event.target.name === "type") {
                setInput((prevInputSettings) => ({ ...prevInputSettings, type: '' }));
            }
        }

        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा') ||
                (event.target.name === 'time' && event.target.value === 'वेळ निवडा')
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if ((prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') && prevElement !== event.target) {
                        prevElement.focus();
                        break;
                    } else prevIndex--;
                } else prevIndex--;
            }
        }

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden={true}
                ref={refdelete}
                data-bs-target="#exampleModaldelete"
            >
            </button>

            <div
                className="modal fade"
                id="exampleModaldelete"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                data-bs-backdrop="static"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                ref={refdeleteclose}
                                aria-label="Close"
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <h4 className="modal-title" id="exampleModalLabel">
                                {t("Newkendra.modal.deleteTitle")}
                            </h4>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                {t("Newkendra.buttons.close")}
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={deleteAccount}
                            >
                                {t("Newkendra.buttons.delete")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden={true}
                ref={refnewkendra}
                data-bs-target="#newkendra"
            >
            </button>

            <div
                className="modal fade"
                id="newkendra"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                data-bs-backdrop="static"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                ref={refnewkedraclose}
                                aria-label="Close"
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <h4 className="modal-title" id="exampleModalLabel">
                                {t("Newkendra.modal.newKendraTitle")}
                            </h4>
                        </div>

                        <line />

                        <div className="boxnewkenra">
                            <div className='rownewkenra0top'>
                                <img className='iconnewkenra' src={user} alt="" />
                                <span>{localStorage.getItem("kendra")}</span>
                            </div>
                            <div className='rownewkenra'>
                                <img className='iconnewkenra' src={mobile} alt="" />
                                <span>{localStorage.getItem("contact") + "-" + (parseFloat(input.kendracount) + 1)}</span>
                            </div>
                            <div className='rownewkenra'>
                                <img className='iconnewkenra' src={location} alt="" />
                                <input
                                    onKeyDown={e => handleEnterKey(e, 49)}
                                    ref={ref => (inputRefs.current[49] = ref)}
                                    className={"form-control inputfont"}
                                    autoComplete='off'
                                    id="citynew"
                                    name="citynew"
                                    placeholder={t("Newkendra.placeholders.villageBranchName")}
                                    value={input.citynew}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                onClick={handlenewkendraclose}
                            >
                                {t("Newkendra.buttons.exit")}
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onKeyDown={e => handleEnterKey(e, 50)}
                                ref={ref => (inputRefs.current[50] = ref)}
                                onClick={createnewuserandkendra}
                            >
                                {t("Newkendra.buttons.yes")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`report ${showreport ? '' : 'hidden'}`}>
                <div className="buttonsreport">
                    <img onClick={handleBack} className='back' src={back} alt="" />
                    <h5 className="modal-title" id="exampleModalLabel">
                        {t("Newkendra.header.kendraListTitle", { type: props.type })}
                    </h5>

                    <div className='row1formkendra'>
                        {localStorage.getItem("plant") === "Yes" ? (
                            <button onClick={handlenewkendra} type="submit" className="btn btn-primary my-3 mx-1">
                                {t("Newkendra.buttons.createNewKendra")}
                            </button>
                        ) : (
                            <button onClick={handlenewkendra} type="submit" className="btn btn-primary my-3 mx-1">
                                {t("Newkendra.buttons.fillKendraInfo")}
                            </button>
                        )}
                    </div>
                </div>

                <table id="table-to-xls" className="table table-bordered">
                    <thead>
                        <tr>
                            <th className='thsmall'>{t("Newkendra.table.kendraNo")}</th>
                            <th className='thsmall'>{t("Newkendra.table.kendraName")}</th>
                            <th className='thsmall'>{t("Newkendra.table.mobile")}</th>
                            <th className='thsmall'>{t("Newkendra.table.mainNo")}</th>
                            <th className='thsmall'>{t("Newkendra.table.villageBranch")}</th>
                            <th className='thsmall'>{t("Newkendra.table.status")}</th>
                            <th className='thsmall'>{t("Newkendra.table.action")}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {value.length > 0 ? tableFilter.map((user, index) =>
                            <tr key={index}>
                                <td className='thsmall'>{index + 1}</td>
                                <td className='thsmall'>{user.name}</td>
                                <td className='thsmall'>{user.mobno}</td>
                                <td className='thsmall'>{user.city}</td>
                                <td className='thsmall'>{user.status === "On" ? t("Newkendra.status.currentOn") : t("Newkendra.status.off")}</td>
                                <td className='thsmall'><UilEditAlt onClick={() => { handleedit(user.sr, user.name, user.mobno, user.city, user.status) }} className="ic" /></td>
                            </tr>
                        )
                            :
                            DataSource.map((user, index) =>
                                <tr key={index}>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}>{index + 1 + "-" + user.sr}</td>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}>{user.name}</td>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}>{user.mobno}</td>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}>{user.parent == 'self' ? user.mobno : user.parent}</td>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}>{user.city}</td>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}>{user.status === "On" ? t("Newkendra.status.currentOn") : t("Newkendra.status.off")}</td>
                                    <td className={user.status === "On" ? "thsmallgreen" : "thsmall"}><UilEditAlt onClick={() => { handleedit(user.sr, user.name, user.mobno, user.city, user.status, user.parent == 'self' ? user.mobno : user.parent) }} className="ic" /></td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

            <div className={`backmain ${showreport ? 'hidden' : ''}`}>
                <img onClick={handleBacktokendra} className='back' src={back} alt="" />
                <div className="custbox">
                    <form>
                        <div className="mb-2 kendra">
                            <span className='subhead'>{t("Newkendra.form.kendraName")}</span>
                            <input
                                disabled={newedit === "edit" ? localStorage.getItem("plant") === "Yes" : ''}
                                onChange={handleChange}
                                onKeyDown={e => handleEnterKey(e, 0)}
                                ref={ref => (inputRefs.current[0] = ref)}
                                type="text"
                                className={newedit === "new" ? "form-control" : "form-control editmode"}
                                id="cname"
                                name="cname"
                                value={input.cname}
                                autoComplete='off'
                            />
                        </div>

                        <div className="mb-2">
                            <span className='subhead'>{t("Newkendra.form.villageBranch")}</span>
                            <input
                                onChange={handleChange}
                                onKeyDown={e => handleEnterKey(e, 1)}
                                ref={ref => (inputRefs.current[1] = ref)}
                                type="text"
                                className={newedit === "new" ? "form-control" : "form-control editmode"}
                                id="city"
                                name="city"
                                value={input.city}
                                autoComplete='off'
                            />
                        </div>

                        <div className="mb-2">
                            <span className='subhead'>{t("Newkendra.form.mobileNo")}</span>
                            <input
                                disabled
                                onChange={handleChange}
                                onKeyDown={e => handleEnterKey(e, 2)}
                                ref={ref => (inputRefs.current[2] = ref)}
                                type="text"
                                className={newedit === "new" ? "form-control" : "form-control editmode"}
                                id="mobno"
                                name="mobno"
                                value={input.mobno}
                                autoComplete='off'
                            />
                        </div>

                        <div className="mb-2">
                            <span className='subhead'>{t("Newkendra.form.mainNo")}</span>
                            <input
                                disabled
                                type="text"
                                className={newedit === "new" ? "form-control" : "form-control editmode"}
                                id="parent"
                                name="parent"
                                value={input.parent}
                                autoComplete='off'
                            />
                        </div>

                        <div className="mb-2">
                            <span className='subheadsank'>{t("Newkendra.form.type")}</span>

                            <select
                                disabled={localStorage.getItem("plant") === "No"}
                                onKeyDown={e => handleEnterKey(e, 3)}
                                ref={ref => (inputRefs.current[3] = ref)}
                                value={input.status}
                                name='status'
                                id='status'
                                onChange={handleChange}
                                className={newedit === "new" ? "form-control" : "form-control editmode"}
                            >
                                <option key={0} value="On">{t("Newkendra.status.on")}</option>
                                <option key={1} value="Off">{t("Newkendra.status.off")}</option>
                            </select>
                        </div>

                        <div className='row1form'>
                            <button
                                onClick={handlesubmit}
                                onKeyDown={e => handleEnterKeybutton(e, 0)}
                                ref={ref => (inputRefs.current[4] = ref)}
                                type="submit"
                                className="btn btn-primary my-3 mx-1"
                            >
                                {newedit === "new" ? t("Newkendra.buttons.save") : t("Newkendra.buttons.update")}
                            </button>

                            {localStorage.getItem("plant") === "Yes" ? (
                                <button type='button' onClick={handleReport} className="btn btn-primary my-3 mx-1">
                                    {t("Newkendra.buttons.kendraList")}
                                </button>
                            ) : ''}
                        </div>
                    </form>
                </div>
            </div>

            <ToastContainer />
        </>
    );
};

export default Newkendra;
